export default __webpack_public_path__ + "static/media/acloudguru.6ea10e19.webp";